import { LoginResponse } from "../types/auth.type";
import { NegocioUser } from "../types/user.type";
import ApiService from "./apiService";

const endpoint = "/api/v1/auth/negocios";

class AuthNegocioService extends ApiService {
  loginNegocio(email: string, password: string) {
    return this.post<LoginResponse>(`${endpoint}/login`, { email, password });
  }

  getDetails() {
    return this.get<NegocioUser>(`${endpoint}/details`, {
      auth: true,
    });
  }
}

const authNegociosService = new AuthNegocioService();
export default authNegociosService;
